import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
export function Progress({ className, value = 0, max = 100, ...props }) {
    const percentage = Math.min(Math.max((value / max) * 100, 0), 100);
    return (_jsx("div", { className: cn('relative h-2 w-full overflow-hidden rounded-full bg-gray-200', className), role: "progressbar", "aria-valuenow": value, "aria-valuemin": 0, "aria-valuemax": max, ...props, children: _jsx("div", { className: "h-full bg-brand-600 transition-all duration-300 ease-in-out", style: { width: `${percentage}%` } }) }));
}
